import { render, staticRenderFns } from "./tryExam.vue?vue&type=template&id=0b4f152c&"
import script from "./tryExam.vue?vue&type=script&lang=js&"
export * from "./tryExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports